<div class="my_modal_data demo-modal-wrapper">

  <!-- Header -->
  <div class="modal-header demo-modal-header">
    <div class="header-spacer"></div>

    <button
      type="button"
      class="btn-close demo-close"
      aria-label="Close"
      (click)="closeModal()">
    </button>
  </div>

  <div class="modal-body demo-modal-body">

    <form [formGroup]="forms" (ngSubmit)="onSubmit()">

      <div
        class="demo-form-container"
        [class.logged-in-demo]="isVerifiedLoggedInUser"
        [class.non-logged-in-demo]="!isVerifiedLoggedInUser">

        <!-- Heading -->
        <div class="demo-form-heading">
          <h3>Book Your Free Demo Class</h3>

          <p>
            Get personalised one-to-one classes with expert teachers.
          </p>
        </div>


        <!-- Name -->
        <div class="form-group floating-field">
          <div class="input-wrapper floating-control">
            <input
              type="text"
              id="name"
              formControlName="name"
              class="form-control demo-input"
              placeholder=" "
              required
              autocomplete="name">

            <label for="name">Name <span>*</span></label>

            <span class="input-icon">
              <svg width="20" height="20" viewBox="0 0 24 24"
                fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
                  stroke="currentColor"
                  stroke-width="1.7"/>
                <path
                  d="M3.5 22C3.5 17.8579 7.30558 14.5 12 14.5C16.6944 14.5 20.5 17.8579 20.5 22"
                  stroke="currentColor"
                  stroke-width="1.7"
                  stroke-linecap="round"/>
              </svg>
            </span>
          </div>

          <div
            *ngIf="submitted && f['name']?.errors?.['required']"
            class="invalid-feedback">
            Name is required.
          </div>
        </div>


        <!-- Phone Number -->
        <div class="form-group floating-field" *ngIf="!isVerifiedLoggedInUser">
          <div class="floating-control">
            <app-country-picker
              formControlName="phoneNumber"
              [isEditPhoneNumber]="true"
              aria-label="Phone number and country code">
            </app-country-picker>

            <!-- <label for="phoneNumber">Phone Number <span>*</span></label> -->
          </div>

          <div
            *ngIf="submitted && f['phoneNumber']?.errors?.['required']"
            class="invalid-feedback">
            Phone number is required.
          </div>

          <div
            *ngIf="submitted && f['phoneNumber']?.errors?.['pattern']"
            class="invalid-feedback">
            Please enter a valid phone number.
          </div>
        </div>


        <!-- Email -->
        <div class="form-group floating-field demo-email-group" *ngIf="!isVerifiedLoggedInUser">
          <div class="input-wrapper floating-control">
            <input
              type="email"
              id="email"
              formControlName="email"
              class="form-control demo-input"
              placeholder=" "
              required
              autocomplete="email">

            <label for="email">Email <span>*</span></label>

            <span class="input-icon">
              <svg width="20" height="20" viewBox="0 0 24 24"
                fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4 5H20C21.1046 5 22 5.89543 22 7V17C22 18.1046 21.1046 19 20 19H4C2.89543 19 2 18.1046 2 17V7C2 5.89543 2 5 4 5Z"
                  stroke="currentColor"
                  stroke-width="1.7"/>
                <path
                  d="M3 7L12 13L21 7"
                  stroke="currentColor"
                  stroke-width="1.7"
                  stroke-linecap="round"
                  stroke-linejoin="round"/>
              </svg>
            </span>
          </div>

          <div
            *ngIf="submitted && f['email']?.errors?.['required']"
            class="invalid-feedback">
            Email is required.
          </div>

          <div
            *ngIf="submitted && f['email']?.errors?.['email']"
            class="invalid-feedback">
            Please enter a valid email address.
          </div>
        </div>


        <!-- Grade -->
        <div class="form-group floating-field">
          <div class="select-wrapper floating-control select-control">
            <select
              id="grade"
              formControlName="selectedGrade"
              class="form-select demo-input"
              required
              (change)="changeGrade($event)">

              <option value="" disabled>
                Select your grade
              </option>

              <option
                *ngFor="let grade of grades; let i = index"
                [value]="grade.id">
                {{ grade.name }}
              </option>

            </select>

            <label for="grade">Grade <span>*</span></label>

            <span class="select-arrow">
              <svg width="18" height="18" viewBox="0 0 24 24"
                fill="none">
                <path
                  d="M6 9L12 15L18 9"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"/>
              </svg>
            </span>

          </div>

          <div
            *ngIf="submitted && f['selectedGrade']?.errors?.['required']"
            class="invalid-feedback">
            Grade is required.
          </div>
        </div>

        <!-- Topic -->
        <div class="form-group demo-topic-group floating-field">
          <div class="floating-control">
            <input
              type="text"
              id="topic"
              formControlName="topic"
              class="form-control demo-input"
              placeholder=" "
              maxlength="200"
              required
              aria-describedby="topic-error">
            <label for="topic">Topic <span>*</span></label>
          </div>
          <div *ngIf="submitted && f['topic']?.invalid" id="topic-error" class="invalid-feedback">
            Topic is required.
          </div>
        </div>

        <!-- Description -->
        <div class="form-group demo-description-group floating-field">
          <div class="floating-control textarea-control">
            <textarea
              id="description"
              formControlName="description"
              class="form-control demo-input demo-textarea"
              placeholder=" "
              rows="4"
              maxlength="500"
              required
              aria-describedby="description-error"></textarea>
            <label for="description">Description <span>*</span></label>
          </div>
          <div *ngIf="submitted && f['description']?.invalid" id="description-error" class="invalid-feedback">
            Description is required.
          </div>
        </div>

        <ng-container *ngIf="!isVerifiedLoggedInUser && !isEmailOtpVerified">
          <div class="turnstile-block" *ngIf="!showOtpSection">
            <label>Security verification <span>*</span></label>
            <div #turnstileContainer class="turnstile-container" aria-label="Bot verification"></div>
          </div>

          <section class="otp-section otp-card" *ngIf="showOtpSection" [formGroup]="otpForm">
            <div class="otp-card__header">
              <div>
                <p class="otp-kicker">Email OTP Verification</p>
                <h3>Enter the 6-digit code</h3>
              </div>
            </div>

            <p class="otp-copy">
              We sent a 6-digit OTP to <strong>{{ forms.get('email')?.value }}</strong>.
            </p>

            <div class="otp-grid" (paste)="onOtpPaste($event)">
              <input
                #otpInput
                *ngFor="let controlName of otpControlNames; let i = index"
                [formControlName]="controlName"
                [id]="'demo-otp-' + i"
                type="text"
                class="otp-box"
                inputmode="numeric"
                maxlength="1"
                [attr.aria-label]="'OTP digit ' + (i + 1)"
                [attr.autocomplete]="i === 0 ? 'one-time-code' : 'off'"
                (input)="onOtpInput(i, $event)"
                (keydown)="onOtpKeydown(i, $event)" />
            </div>

            <div *ngIf="otpSubmitted && otpForm.invalid" id="otp-error" class="invalid-feedback">
              Enter the 6-digit OTP.
            </div>
          </section>
        </ng-container>


        <!-- CTA -->
        <button
          type="submit"
          class="modal-submit-btn"
          [disabled]="submitting || sendingOtp || verifyingOtp || turnstileLoading">

          <span>
            {{ submitting ? 'Submitting...' : verifyingOtp ? 'Verifying OTP...' : sendingOtp ? 'Sending OTP...' : turnstileLoading ? 'Loading verification...' : showOtpSection ? 'Verify OTP and Request Demo' : isVerifiedLoggedInUser ? 'Request a Free Demo' : 'Verify Email' }}
          </span>

          <svg
            width="19"
            height="19"
            viewBox="0 0 24 24"
            fill="none">

            <path
              d="M5 12H19"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"/>

            <path
              d="M13 6L19 12L13 18"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"/>

          </svg>

        </button>


        <!-- Bottom note -->
        <div class="demo-form-footer">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
              stroke="currentColor"
              stroke-width="1.7"/>
            <path
              d="M12 8V12L15 14"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"/>
          </svg>

          <span>Our counsellor will contact you shortly.</span>
        </div>

      </div>

    </form>

  </div>
</div>
